import styled from 'styled-components';
import { Card as card } from 'antd';

const Card = styled(card)`
`;

export default Card;
